var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ListingTableFilter",
    {
      attrs: {
        filter: _vm.filter,
        valuesHumanized: _vm.appliedFilterLabels,
        filterConfig: _vm.filterConfig
      },
      on: {
        updateFilter: _vm.updateFilter,
        updateVisibility: _vm.updateVisibility,
        removeFilter: _vm.removeFilter
      }
    },
    [
      _c(
        "template",
        { slot: "filterDropdownContent" },
        [
          _vm.filter.options.corp
            ? _c("CompassDropdownOption", {
                attrs: {
                  label: _vm.labels.filter.options.corp,
                  avatar: { type: "company" },
                  type: "avatar",
                  value: "company"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.filter.options.staff
            ? [
                _c(
                  "li",
                  {
                    staticClass:
                      "listing-filter-dropdown-select-users-parent-option typographies-paragraph-small-semibold"
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.labels.filter.options.staff) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _vm._l(_vm.filter.options.staff, function(staff) {
                  return _c("CompassDropdownOption", {
                    key:
                      "listing-filters-select-users-" +
                      staff.code +
                      "-" +
                      staff.value,
                    attrs: {
                      label: staff.label,
                      value: staff.code + "-" + staff.value,
                      avatar: {
                        initials: staff.initials,
                        colorType: staff.colorType,
                        photo: staff.avatar
                      },
                      type: "avatar"
                    }
                  })
                })
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.filter.options.group
            ? [
                _c(
                  "li",
                  {
                    staticClass:
                      "listing-filter-dropdown-select-users-parent-option typographies-paragraph-small-semibold"
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.labels.filter.options.group) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _vm._l(_vm.filter.options.group, function(group) {
                  return _c("CompassDropdownOption", {
                    key:
                      "listing-filters-select-users-" +
                      group.code +
                      "-" +
                      group.value,
                    attrs: {
                      label: group.label,
                      value: group.code + "-" + group.value,
                      avatar: { type: "team" },
                      type: "avatar"
                    }
                  })
                })
              ]
            : _vm._e()
        ],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }